angular.module("digitalLeasing.module")
    .component("corporateDataStructure", {
        templateUrl: "ng/components/digitalLeasing/corporateDataStructure/corporateDataStructure.view.html",
        bindings: {
            model: "=",
            validatePage: '&',
            invalidatePage: '&',
            snapshot: '<',
            viewMode: '<',
            portalRunned: '<'
        },
        controllerAs: "corporateStructureCtrl",
        controller: CorporateDataStructure
    })

function CorporateDataStructure(
    FinancialModel,
    CodiceNaturaClientela,
    MotivoRapporto
) {

    var self = this;

    self.$onInit = function () {
        jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0); //posiziona la scollBar in top ad ogni cambio vista
        checkPage();
    }

    self.individualsOk = function () {
        self.individualsOkValue = true;
        checkPage();

    }

    self.individualsNotOk = function () {
        self.individualsOkValue = false;
        checkPage();

    }

    self.handleStructureChange = function (name, value) {
        self.model.financialCustomer.metadata.adeguataVerifica.codiceNaturaClientela = CodiceNaturaClientela.build({
            description: value.codiceNaturaClientela.description,
            name: value.codiceNaturaClientela.name,
            value: value.codiceNaturaClientela.value,
        });
        self.model.financialCustomer.metadata.adeguataVerifica.motivoRapporto = MotivoRapporto.build({
            description: value.motivoRapporto.description,
            name: value.motivoRapporto.name,
            value: value.motivoRapporto.value,
        });
        self.model.financialCustomer.metadata.adeguataVerifica.provinciaAttivita = value.provinciaAttivita;
        checkPage();
    }

    var checkPage = function () {
        var test = ((self.model.financialCustomer.metadata.adeguataVerifica.codiceNaturaClientela &&
                self.model.financialCustomer.metadata.adeguataVerifica.codiceNaturaClientela.description &&
                self.model.financialCustomer.metadata.adeguataVerifica.codiceNaturaClientela.name &&
                self.model.financialCustomer.metadata.adeguataVerifica.codiceNaturaClientela.value &&
                self.model.financialCustomer.metadata.adeguataVerifica.motivoRapporto &&
                self.model.financialCustomer.metadata.adeguataVerifica.motivoRapporto.description &&
                self.model.financialCustomer.metadata.adeguataVerifica.motivoRapporto.name &&
                self.model.financialCustomer.metadata.adeguataVerifica.motivoRapporto.value &&
                self.model.financialCustomer.metadata.adeguataVerifica.provinciaAttivita) || !self.model.taskFiliale) &&
            self.individualsOkValue

        if (self.individualsOkValue) {
            self.validatePage();
        } else {
            self.invalidatePage();
        }

    }
}